import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Label = styled.label `
  display: block;
  width: 100%;

  &[data-font-style='default'] {
    ${fonts.montserrat.medium}
    font-size: 20px;
    line-height: 32px;
  }

  &[data-font-style='text'] {
    ${fonts.montserrat.regular}
    font-size: 18px;
    line-height: 28px;
  }
`;
export default {
    Label,
};
